module.exports = __webpack_public_path__ + "static/media/image-gallery-4.fe497786.jpg";